import { isEmpty, isNil } from 'lodash';
import { API } from '@shared/types/api';
import { PM60, useFeatureFlag } from '@shared/util/featureFlags';

interface UseIsNeverEnabledProps {
  minimumInSeries?: number;
  tagFilter?: API.FilterByComponentFragment;
}

export function useIsNeverEnabled({ minimumInSeries, tagFilter }: UseIsNeverEnabledProps): boolean {
  const isPM60Enabled = useFeatureFlag(PM60);

  const hasTagFilter = !isEmpty(tagFilter?.componentId);

  return isPM60Enabled && !isNil(minimumInSeries) && hasTagFilter;
}
